"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionType = void 0;
var styles = require("./Tooltip.scss");
exports.PositionType = {
    top: styles.positionTop,
    bottom: styles.positionBottom,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tooltip/TooltipProps.js
// module id = 1663
// module chunks = 8